export const UpFrontMultiAttributeComparisonNew = [
    // Header section
    { span: 15, height: "32px", classes: "marginTop-8" }, // Main header

    // Questions container - flat structure
    { span: 15, height: "56px", classes: "marginTop-16" }, // First accordion header

    { span: 15, height: "56px", classes: "marginTop-16" }, // Second accordion header

    { span: 15, height: "56px", classes: "marginTop-16" }, // Third accordion header

    { span: 15, height: "56px", classes: "marginTop-16" }, // Fourth accordion header

    { span: 15, height: "56px", classes: "marginTop-16" }, // Fifth accordion header

    { span: 2, height: "40px", classes: "marginTop-16" }, // Fifth accordion header
]
